import {
  Form,
  Input,
  Row,
  Col,
  Select,
  DatePicker,
  Upload,
  Spin,
  Button,
  Flex,
  Radio,
  InputNumber, // added
} from "antd";
import {
  UserOutlined,
  FileTextOutlined,
  DeleteOutlined,
  PaperClipOutlined,
  TagOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import ReactQuill from "react-quill";
import moment from "moment";
import { useParams } from "react-router-dom";

const { Option } = Select;
const { Dragger } = Upload;

function CreateSolution({
  loading,
  isSubmitLoading,
  handleFileChange,

  onSubmit,
  subscribers,
  fileTypes,
  formData,
  setFormData,
  dropdownData,
  handleTimezoneChange,
  handleDescriptionChange,
  setFileList,
  fileList,
  selectedRadio,
  handleRadioChange,
  feedbackDropdownData,
}) {
  const [form] = Form.useForm();
  const { orderKey } = useParams();

  // Remove duplicate file types based on 'file_type' property
  const uniqueFileTypes = fileTypes.reduce((acc, current) => {
    const x = acc.find((item) => item.file_type === current.file_type);
    if (!x) acc.push(current);
    return acc;
  }, []);
  const getFileIcon = (fileName) => {
    const extension = fileName?.split(".").pop().toLowerCase();

    switch (extension) {
      case "pdf":
        return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/PDF_file_icon.svg.png";
      case "doc":
      case "docx":
        return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/docx_icon.svg.png";
      case "jpg":
      case "jpeg":
        return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/jpeg-jpg.png";
      case "png":
        return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/png1.webp";
      case "zip":
        return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/zipppp.png";
      case "ppt":
      case "pptx":
        return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/images_1.png";
      default:
        return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/file-file-type.svg";
    }
  };

  const getFormattedFileName = (fileName) => {
    const extensionIndex = fileName.lastIndexOf(".");
    const baseName =
      extensionIndex !== -1 ? fileName.substring(0, extensionIndex) : fileName;
    const extension =
      extensionIndex !== -1 ? fileName.substring(extensionIndex) : "";

    if (baseName.length > 14) {
      return {
        displayName: `${baseName.substring(0, 14)}...${extension}`,
        fullName: fileName,
      };
    }
    return {
      displayName: fileName,
      fullName: fileName,
    };
  };

  const handleDeleteFile = (index) => {
    const updatedFileList = [...fileList];
    updatedFileList.splice(index, 1); // Remove the file at the specified index
    setFileList(updatedFileList); // Update the state with the new file list

    // Update formData.files to remove the corresponding file
    const updatedFiles = [...formData.files];
    updatedFiles.splice(index, 1); // Remove the file at the specified index
    setFormData((prevData) => ({ ...prevData, files: updatedFiles })); // Update files in formData
  };

  const formatFeedbackKey = (itemKey, orderKey) => {
    return itemKey.replace(orderKey, "").replace(/^-|-$/g, "").trim();
  };

  // new: wrapper to auto-fetch extensions and update submission_file_format
  const onFilesChange = (info) => {
    const files = info.fileList.map((f) => ({
      uid: f.uid,
      name: f.name,
      file: f.originFileObj,
      file_type: null, // 👈 per-file
    }));

    setFileList(files);

    const extensions = [
      ...new Set(
        files
          .map((f) => f.name.split(".").pop()?.toUpperCase())
          .filter(Boolean)
      ),
    ];

    setFormData((prev) => ({
      ...prev,
      files,
      submission_file_format: extensions.join(", "),
    }));
  };


  return (
    <Flex style={{ width: "100%" }}>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
            width: "100%",
          }}
        >
          <Spin size="large" />
        </div>
      ) : (
        <Form
          form={form}
          layout="vertical"
          encType="multipart/form-data"
          style={{ width: "100%", height: "max-content" }}
        >
          <Col sm={24} style={{ width: "100%" }}>
            <Form.Item style={{ marginTop: "6px", width: "100%" }}>
              <label>Files</label>
              <div
                className="file-parent "
                style={{
                  marginTop: "8px",
                  minHeight: "160px",
                  maxHeight: "160px",
                  overflowY: "scroll",
                  width: "100%",
                }}
              >
                <div className="file-container">
                  {fileList?.length === 0 ? (
                    <Flex
                      vertical
                      justify="center"
                      style={{ width: "100%", minHeight: "100px" }}
                      className="file-preview-container"
                    >
                      <Dragger
                        style={{
                          width: "100%",
                          background: "none",
                          border: "none",
                        }}
                        showUploadList={false} // Hide Ant Design's automatic file list
                        beforeUpload={() => false} // Prevent automatic upload
                        onChange={onFilesChange} // Handle file selection + auto extensions
                        fileList={fileList} // Set fileList state for controlled uploads
                        multiple // Allow multiple file uploads
                        listType="text" // Display file names below the input
                      >
                        <p
                          className="ant-upload-text "
                          style={{ color: "gray", marginTop: "50px" }}
                        >
                          Drag & drop files here or click to upload
                        </p>
                      </Dragger>
                    </Flex>
                  ) : (
                    <></>
                    // <div
                    //   className="file-preview-container"
                    //   style={{ display: "flex", flexWrap: "wrap" }}
                    // >
                    //   {fileList?.map((file, index) => {
                    //     const { displayName, fullName } = getFormattedFileName(file.name);

                    //     return (
                    //       <div
                    //         key={file.uid}
                    //         className="file-preview-item"
                    //         style={{
                    //           margin: "10px",
                    //           display: "flex",
                    //           alignItems: "center",
                    //           border: "1px solid #d9d9d9",
                    //           padding: "6px",
                    //           borderRadius: "4px",
                    //           flexDirection: "column",
                    //           width: "100%",
                    //         }}
                    //       >
                    //         <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                    //           <img
                    //             style={{ height: "40px", width: "40px", marginRight: "8px" }}
                    //             src={getFileIcon(file.name)}
                    //             alt="file-icon"
                    //           />
                    //           <span title={fullName}>{displayName}</span>
                    //           <DeleteOutlined
                    //             style={{ marginLeft: "auto", cursor: "pointer" }}
                    //             onClick={() => handleDeleteFile(index)}
                    //           />
                    //         </div>

                    //         {/* ✅ FILE TYPE PER FILE — CSS SAME */}
                    //         <Select
                    //           style={{ width: "100%", marginTop: "6px" }}
                    //           placeholder="Select File Type"
                    //           value={file.file_type || undefined}
                    //           onChange={(value) => {
                    //             const updated = [...fileList];
                    //             updated[index].file_type = value;
                    //             setFileList(updated);
                    //             setFormData((prev) => ({ ...prev, files: updated }));
                    //           }}
                    //         >
                    //           {uniqueFileTypes.map((type) => (
                    //             <Option key={type.uuid} value={type.uuid}>
                    //               {type.file_type}
                    //             </Option>
                    //           ))}
                    //         </Select>
                    //       </div>
                    //     );
                    //   })}

                    // </div>
                  )}
                </div>
                <Upload
                  showUploadList={false} // Hide Ant Design's automatic file list
                  beforeUpload={() => false} // Prevent automatic upload
                  onChange={onFilesChange}
                  fileList={fileList} // Set fileList state for controlled uploads
                  multiple // Allow multiple file uploads
                  listType="text" // Display file names below the input
                >
                  <div
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <PaperClipOutlined
                      style={{ fontSize: "24px", marginRight: "8px" }}
                    />
                  </div>
                </Upload>
              </div>
            </Form.Item>
          </Col>
           <div
                      className="file-preview-container"
                      style={{ display: "flex", flexWrap: "wrap" }}
                    >
                      {fileList?.map((file, index) => {
                        const { displayName, fullName } = getFormattedFileName(file.name);

                        return (
                          <div
                            key={file.uid}
                            className="file-preview-item"
                            style={{
                              margin: "10px",
                              display: "flex",
                              alignItems: "center",
                              border: "1px solid #d9d9d9",
                              padding: "6px",
                              borderRadius: "4px",
                              flexDirection: "column",
                              width: "100%",
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                              <img
                                style={{ height: "40px", width: "40px", marginRight: "8px" }}
                                src={getFileIcon(file.name)}
                                alt="file-icon"
                              />
                              <span title={fullName}>{displayName}</span>
                              <DeleteOutlined
                                style={{ marginLeft: "auto", cursor: "pointer" }}
                                onClick={() => handleDeleteFile(index)}
                              />
                            </div>

                            {/* ✅ FILE TYPE PER FILE — CSS SAME */}
                            <Select
                              style={{ width: "100%", marginTop: "6px" }}
                              placeholder="Select File Type"
                              value={file.file_type || undefined}
                              onChange={(value) => {
                                const updated = [...fileList];
                                updated[index].file_type = value;
                                setFileList(updated);
                                setFormData((prev) => ({ ...prev, files: updated }));
                              }}
                            >
                              {uniqueFileTypes.map((type) => (
                                <Option key={type.uuid} value={type.uuid}>
                                  {type.file_type}
                                </Option>
                              ))}
                            </Select>
                          </div>
                        );
                      })}

                    </div>
          {/* <Form.Item
            label="File types"
            // name="file-Types"
            style={{ width: "100%" }}
            rules={[{ required: true, message: "Please Select a File Type" }]}
          >
            <Select
              showSearch
              value={formData.file_type || undefined}
              placeholder="Select a File Type"
              placement="bottom"
              onChange={(value) =>
                setFormData({ ...formData, file_type: value })
              }
              filterOption={(input, option) =>
                (option?.children ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            >
              {uniqueFileTypes.map((type) => (
                <Option key={type.uuid} value={type.uuid}>
                  {type.file_type}
                </Option>
              ))}
            </Select>
          </Form.Item> */}
          {feedbackDropdownData?.length > 0 && (
            <Form.Item
              label="Feedback"
              // name="feedback-dropdown"
              style={{ width: "100%" }}
              rules={
                feedbackDropdownData.length > 0
                  ? [
                    {
                      required: true,
                      message: "Please select at least one feedback",
                    },
                  ]
                  : []
              }
            >
              <Select
                mode="multiple"
                showSearch
                value={formData.feedback_uids || undefined}
                placeholder="Select Feedback(s)"
                placement="bottom"
                onChange={(value) =>
                  setFormData({ ...formData, feedback_uids: value })
                }
                filterOption={(input, option) =>
                  (option?.children ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                {feedbackDropdownData.map((item, index) => {
                  const formattedKey = formatFeedbackKey(item.key, orderKey);
                  return (
                    <Option key={index} value={item.uid}>
                      {formattedKey} -{" "}
                      {moment(item.date).local().format("DD-MM-YYYY hh:mm A")}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          )}
          <Row style={{ width: "100%" }} gutter={[16, 8]}>
            <Col sm={24} style={{ width: "100%" }}>
              <Form.Item
                label="Remarks"
                required
                rules={[{ required: true, message: "Please enter remark" }]}
              >
                <Input.TextArea
                  required={true}
                  placeholder="Enter the remark"
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      remarks: e.target.value,
                    })
                  }
                  rows={4} // Adjust the number of rows as needed
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Quality Check Questions */}
          {/* <Row style={{ width: "100%" }}>
            <Col sm={24} style={{ width: "100%" }}>
              <Form.Item
                label="Quality Check Completed?"
                required
                style={{ marginBottom: "12px" }}
              >
                <Radio.Group
                  value={formData.quality_check_completed}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      quality_check_completed: e.target.value,
                    })
                  }
                >
                  <Radio value={true}>Yes</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row> */}

          {/* <Row style={{ width: "100%" }}>
            <Col sm={24} style={{ width: "100%" }}>
              <Form.Item
                label="Grammarly Check Completed?"
                required
                style={{ marginBottom: "12px" }}
              >
                <Radio.Group
                  value={formData.grammarly_check_completed}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      grammarly_check_completed: e.target.value,
                    })
                  }
                >
                  <Radio value={true}>Yes</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row> */}

          {/* <Row style={{ width: "100%" }}>
            <Col sm={24} style={{ width: "100%" }}>
              <Form.Item
                label="Proofreading Completed?"
                required
                style={{ marginBottom: "12px" }}
              >
                <Radio.Group
                  value={formData.proofreading_completed}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      proofreading_completed: e.target.value,
                    })
                  }
                >
                  <Radio value={true}>Yes</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row> */}

          {/* <Row style={{ width: "100%" }}>
            <Col sm={24} style={{ width: "100%" }}>
              <Form.Item
                label="Author Details Removed?"
                required
                style={{ marginBottom: "12px" }}
              >
                <Radio.Group
                  value={formData.author_details_removed}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      author_details_removed: e.target.value,
                    })
                  }
                >
                  <Radio value={true}>Yes</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row> */}

          <Row style={{ width: "100%" }} gutter={[16, 8]}>
            <Col sm={24} style={{ width: "100%" }}>
              <Form.Item
                label="AI Report Added?"
                required
                style={{ marginBottom: "12px" }}
              >
                <Radio.Group
                  value={formData.ai_report_added}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      ai_report_added: e.target.value,
                    })
                  }
                >
                  <Radio value={true}>Yes</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>

          <Row style={{ width: "100%" }} gutter={[16, 8]}>
            <Col sm={24} style={{ width: "100%" }}>
              <Form.Item
                label="Plag Report Added?"
                required
                style={{ marginBottom: "12px" }}
              >
                <Radio.Group
                  value={formData.plag_report_added}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      plag_report_added: e.target.value,
                    })
                  }
                >
                  <Radio value={true}>Yes</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>

          {/* New fields added: task type, word count, english country, referencing format, submission file format, expert rating */}
          <Row style={{ width: "100%" }} gutter={[16, 8]}>
            <Col sm={24}>
              <Form.Item
                label="Task Type"
                required
                rules={[{ required: true, message: "Please select Task Type" }]}
              >
                <Select
                  value={formData.task_type || undefined}
                  placeholder="Select Task Type"
                  onChange={(value) =>
                    setFormData({ ...formData, task_type: value })
                  }
                >
                  <Option value="regular">Regular</Option>
                  <Option value="feedback">Feedback</Option>
                  <Option value="milestone">Milestone</Option>
                  <Option value="amendment">Amendment</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row style={{ width: "100%" }} gutter={[16, 8]}>
            <Col sm={12}>
              <Form.Item
                label="Word Count Achieved"
                required
                rules={[{ required: true, message: "Please enter word count" }]}
              >
                <InputNumber
                  min={0}
                  style={{ width: "100%" }}
                  placeholder="Final word count"
                  value={formData.word_count_achieved ?? undefined}
                  onChange={(value) =>
                    setFormData({ ...formData, word_count_achieved: value })
                  }
                />
              </Form.Item>
            </Col>

            <Col sm={12} style={{ width: "100%" }}>
              <Form.Item
                label="Expert Rating"
                required
                rules={[
                  { required: true, message: "Please enter rating" },
                  {
                    type: "number",
                    min: 0,
                    max: 10,
                    message: "Rating must be between 0 and 10",
                  },
                ]}
              >
                <InputNumber
                  min={0}
                  max={10}
                  style={{ width: "100%" }}
                  placeholder="Enter rating (0-10)"
                  value={formData.expert_rating ?? undefined}
                  onChange={(value) =>
                    setFormData({ ...formData, expert_rating: value })
                  }
                />
              </Form.Item>
            </Col>
          </Row>

          <Row style={{ width: "100%" }} gutter={[16, 8]}>
            <Col sm={12}>
              <Form.Item
                label="English Country"
                required
                rules={[{ required: true, message: "Please select country" }]}
              >
                <Select
                  value={formData.english_country || undefined}
                  placeholder="Select English country"
                  onChange={(value) =>
                    setFormData({ ...formData, english_country: value })
                  }
                >
                  <Option value="us">US</Option>
                  <Option value="uk">UK</Option>
                  <Option value="australia">Australia</Option>
                  <Option value="other">Other</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col sm={12}>
              {/* show when 'other' selected and required */}
              {formData.english_country === "other" && (
                <Form.Item
                  label="English Country (Other)"
                  required
                  rules={[
                    { required: true, message: "Please specify country" },
                  ]}
                >
                  <Input
                    placeholder="Specify country"
                    value={formData.english_country_other || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        english_country_other: e.target.value,
                      })
                    }
                  />
                </Form.Item>
              )}
            </Col>
          </Row>

          <Row style={{ width: "100%" }} gutter={[16, 8]}>
            <Col sm={12}>
              <Form.Item
                label="Referencing Format"
                required
                rules={[
                  { required: true, message: "Please select referencing format" },
                ]}
              >
                <Select
                  value={formData.referencing_format || undefined}
                  placeholder="Select referencing format"
                  onChange={(value) =>
                    setFormData({ ...formData, referencing_format: value })
                  }
                >
                  <Option value="harvard">Harvard</Option>
                  <Option value="apa7">APA 7th</Option>
                  <Option value="apa6">APA 6th</Option>
                  <Option value="ieee">IEEE</Option>
                  <Option value="oscola">OSCOLA</Option>
                  <Option value="other">Other</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col sm={12}>
              {formData.referencing_format === "other" && (
                <Form.Item
                  label="Referencing Format (Other)"
                  required
                  rules={[
                    { required: true, message: "Please specify referencing format" },
                  ]}
                >
                  <Input
                    placeholder="Specify referencing format"
                    value={formData.referencing_format_other || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        referencing_format_other: e.target.value,
                      })
                    }
                  />
                </Form.Item>
              )}
            </Col>
          </Row>

          <Row style={{ width: "100%" }} gutter={[16, 8]}>
            <Col sm={24}>
              <Form.Item
                label="Submission File Format"
                required
                rules={[
                  { required: true, message: "Submission file format is required" },
                ]}
              >
                <Input
                  placeholder="Enter submission file format (e.g. PDF, DOCX)"
                  value={formData.submission_file_format || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      submission_file_format: e.target.value,
                    })
                  }
                />
              </Form.Item>
            </Col>
          </Row>

          <Row justify="end" style={{ width: "100%", marginTop: "20px" }}>
            <Button
              loading={isSubmitLoading}
              type="primary"
              htmlType="submit"
              onClick={onSubmit}
            >
              Submit
            </Button>
          </Row>
          {/* <Form.Item
            label="Subscriber"
            name="subscriber"
            style={{ width: "100%" }}
            rules={[
              { required: true, message: "Please select a subscriber!" },
            ]}>
            <Select
              placeholder="Select a subscriber"
              onChange={(value) =>
                setFormData({ ...formData, subscriberId: value })
              }>
              {subscribers?.map((subscriber) => (
                <Option key={subscriber.username} value={subscriber.username}>
                  {subscriber.subscriber}{" "}
                  {/* Adjust property to match your data */}

          {/* Remaining form sections */}
        </Form>
      )}
    </Flex>
  );
}

export default CreateSolution;
